export const METERS_IN_MILE = 1609.34
export const METERS_IN_FOOT = 0.3048
export const METERS_IN_KM = 1000
export const FEET_IN_MILE = 5280
export const SECONDS_IN_MINUTE = 60
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60
